import { TimerRing } from '@sorrem-client/ui/components/TimerRing';

interface CoalescingProgressProps {
    /** `Date.now()` milliseconds. */
    startedAtMs: number;
    /** `Date.now()` milliseconds. */
    completesAtMs: number;
    /** Ring color, e.g. the crystal type's. */
    color: string;
}

/**
 * A ring filling clockwise around a slot while a crystal coalesces into it,
 * with the seconds left in the corner.
 *
 * TODO: draw the ring with the generated smoke-band art (masked by the same
 * conic gradient) once it exists.
 */
export function CoalescingProgress({ startedAtMs, completesAtMs, color }: CoalescingProgressProps): JSX.Element {
    return <TimerRing startedAtMs={startedAtMs} endsAtMs={completesAtMs} color={color} mode='fill' secondsPlacement='corner' />;
}
